import { useState } from "react";
import { serverGql } from "__generated__/serverGql";
import useAsyncCompleteToast from "components/UI/Notifications/useAsyncCompleteToast";
import serverClient from "lib/apollo/serverClient";
import { assertPresence } from "utils/assertions";
import { BRAND_BILLING } from "lib/routing/links";

const mutation = serverGql(/* ServerGraphQL */ `
  mutation CreateStripeSubscriptionCheckoutSession(
    $brandId: UUID!
    $accessPlanId: UUID!
    $successUrl: String!
    $cancelUrl: String!
  ) {
    createStripeSubscriptionCheckoutSession(
      brandId: $brandId
      accessPlanId: $accessPlanId
      successUrl: $successUrl
      cancelUrl: $cancelUrl
    ) {
      url
    }
  }
`);

type CreateStripeSubscriptionCheckoutSessionParams = {
  accessPlanId: UUID;
  brandId: UUID;
  cancelPath?: string;
  successPath?: string;
};

export default function useCreateStripeSubscriptionCheckoutSession() {
  const [isLoading, setIsLoading] = useState(false);

  const { showErrorToast } = useAsyncCompleteToast();

  const createStripeSubscriptionCheckoutSession = ({
    accessPlanId,
    brandId,
    cancelPath,
    successPath,
  }: CreateStripeSubscriptionCheckoutSessionParams) => {
    setIsLoading(true);

    const getUrl = (path: string) => `${window.location.origin}${path}`;

    serverClient
      .mutate({
        mutation,
        variables: {
          accessPlanId,
          brandId,
          successUrl: getUrl(successPath ?? BRAND_BILLING),
          cancelUrl: getUrl(cancelPath ?? BRAND_BILLING),
        },
      })
      .then((response) => {
        const url = response.data?.createStripeSubscriptionCheckoutSession?.url;
        assertPresence(url, "Expected subscription checkout URL to be defined");
        window.location.href = url;
      })
      .catch((reason: unknown) => {
        showErrorToast(reason);
        setIsLoading(false);
      });
  };

  return { createStripeSubscriptionCheckoutSession, isLoading };
}
